<template>
    <v-container>
        <v-row>
            <v-col class="pt-0">

                <!-- Page title -->
                <!-- <div class="section-heading mt-0">
                    {{ $t(`SeznamPogodb.PogodbeEdit.Title`) }}
                </div> -->

                <div class="d-flex justify-space-between align-center mb-4 mt-0">

                    <!-- Contract no. -->
                    <div class="d-flex ga-8 align-center">
                        <img src="@assets/images/contract-list/icon-contract.svg" alt="Pogodba">

                        <div>
                            <div class="contract-details__title">
                                {{ $t(`SeznamPogodb.PogodbeEdit.ContractNumber`) }} {{ pogodbaDetails.StPogodbe }}
                            </div>

                            <div class="contract-details__timestamp">
                                {{ getDateTimeCorrectedFormat(pogodbaDetails.Vneseno) }}
                            </div>
                        </div>

                    </div>

                    <div class="d-flex ga-4">

                        <!-- Btn stroniraj -->
                        <v-btn
                            v-if="pogodbaDetails.StatusPogodbe != 140 && pogodbaDetails.StatusPogodbe != 170 && pogodbaDetails.StatusPogodbe != 160"
                            flat class="btn btn--primary-fill" @click="stornoDisplay = true">
                            Storniraj
                        </v-btn>

                        <!-- Btn sign -->
                        <v-btn
                            v-if="!pogodbaDetails.EPodpisKoncan && pogodbaDetails.StatusPogodbe != 140 && pogodbaDetails.StatusPogodbe != 170 && pogodbaDetails.StatusPogodbe != 160"
                            flat class="btn btn--primary-fill" @click="seznamPogodbStore.pogodbaPodpisLater('seznam')">
                            Podpiši pogodbo
                        </v-btn>

                        <!-- Btn identify -->
                        <v-btn v-if="pogodbaDetails.ShowCompleteContract" flat class="btn btn--primary-fill"
                            @click="dokoncanjePogodbeStore.getPogodba(pogodbaDetails.PogodbaId)">
                            Identificiraj
                        </v-btn>


                    </div>

                </div>

                <!-- Separator -->
                <hr class="hr mb-8" />

                <v-row>

                    <!-- Contract overview ***************************************************** -->
                    <v-col class="v-col-4">

                        <div class="contract-details__title">
                            Podrobnosti
                        </div>

                        <!-- Stranka -->
                        <div class="contract-details__info">
                            <div class="contract-details__label">{{ $t(`SeznamPogodb.PogodbeEdit.Table.Client`) }}</div>
                            <div>
                                <div class="contract-details__value">{{ pogodbaDetails.Stranka }}</div>
                                <!-- <div class="contract-details__text">DŠ: {{ pogodbaDetails.DavcnaSt }}</div> -->
                            </div>
                        </div>

                        <!-- Status -->
                        <div class="contract-details__info">
                            <div class="contract-details__label">Status</div>
                            <div>
                                <span class="tag" :class="'tag--' + PogodbaStatus[pogodbaDetails.StatusPogodbe!]">
                                    {{ i18n.global.t("ContractStatus." + PogodbaStatus[pogodbaDetails.StatusPogodbe!])
                                    }}
                                </span>
                            </div>
                        </div>

                        <!-- Vrednost -->
                        <div class="contract-details__info">
                            <div class="contract-details__label">{{ $t(`SeznamPogodb.PogodbeEdit.Table.CreditAmount`) }}
                            </div>
                            <div>
                                <div class="contract-details__value amount">{{ pogodbaDetails.Znesek.toFixed(2) }} EUR
                                </div>
                                <div class="contract-details__text">{{ pogodbaDetails.Rocnost }} obrokov</div>
                            </div>
                        </div>

                        <!-- Produkt -->
                        <div class="contract-details__info">
                            <div class="contract-details__label">{{ $t(`SeznamPogodb.PogodbeEdit.Table.Product`) }}
                            </div>
                            <div>
                                <div class="contract-details__value">{{ pogodbaDetails.Produkt }}</div>
                                <div class="contract-details__text">{{ pogodbaDetails.Dokumentacija }}</div>
                            </div>
                        </div>

                        <!-- Vnesel -->
                        <div class="contract-details__info">
                            <div class="contract-details__label">{{ $t(`SeznamPogodb.PogodbeEdit.Table.User`) }}</div>
                            <div class="contract-details__value">{{ pogodbaDetails.Vnesel }}</div>
                        </div>

                        <!-- Poslovalnica -->
                        <div class="contract-details__info">
                            <div class="contract-details__label">{{ $t(`SeznamPogodb.PogodbeEdit.Table.Office`) }}</div>
                            <div>
                                <div class="contract-details__value">{{ pogodbaDetails.Poslovalnica }}</div>
                                <div class="contract-details__text">{{ 'Podpisano: ' + i18n.global.t("SignType." +
                                    pogodbaDetails.Podpis) }}</div>
                            </div>
                        </div>

                        <!-- Št. računa -->
                        <div class="contract-details__info">
                            <div class="contract-details__label">{{ $t(`SeznamPogodb.PogodbeEdit.Table.AccountNumber`)
                            }}
                            </div>
                            <div class="contract-details__value">{{ pogodbaDetails.StRacuna == '' ? '-' :
                                pogodbaDetails.StRacuna }}</div>
                        </div>

                        <div v-if="pogodbaDetails.StatusPogodbe == 110" class="d-flex mt-8">

                            <!-- Btn Izpis pogodbe -->
                            <v-btn class="btn btn--sm btn--default-fill mr-2"
                                @click="RenderReport('GetKreditnaPogodba', 'KreditnaPogodba')">
                                {{ $t(`SeznamPogodb.PogodbeEdit.BtnContract`) }}
                            </v-btn>

                            <!-- Btn Izpis dokumentacije -->
                            <v-btn class="btn btn--sm btn--default-fill"
                                @click="RenderReport('GetDokumentacija', 'Dokumentacija')">
                                {{ $t(`SeznamPogodb.PogodbeEdit.BtnDocumentation`) }}
                            </v-btn>

                        </div>

                    </v-col>

                    <!-- Documentation -->
                    <v-col class="v-col-3">
                        <div class="contract-details__title">
                            Dokumentacija
                        </div>

                        <div class="contract-details__document-owner mt-8"
                            v-if="pogodbaDetails.Dokumenti.filter((d: any) => d.stranka === true).length > 0">Stranka
                        </div>
                        <div>
                            <div class="contract-details__document"
                                v-for="dokument in pogodbaDetails.Dokumenti.filter((d: any) => d.stranka === true)"
                                :key="dokument.key">
                                <img :src="getDocumentStatusIcon(dokument.nalozen)" alt="Status">
                                <div>
                                    <div class="contract-details__document__title">{{ dokument.naziv }}</div>
                                    <div class="contract-details__dovument__description">{{ dokument.opis }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="contract-details__document-owner mt-4"
                            v-if="pogodbaDetails.Dokumenti.filter((d: any) => d.stranka === false).length > 0">Prodajno
                            mesto
                        </div>
                        <div>
                            <div class="contract-details__document"
                                v-for="dokument in pogodbaDetails.Dokumenti.filter((d: any) => d.stranka === false)"
                                :key="dokument.key">
                                <img :src="getDocumentStatusIcon(dokument.nalozen)" alt="Status">
                                <div>
                                    <div class="contract-details__document__title">{{ dokument.naziv }}</div>
                                    <div class="contract-details__dovument__description">{{ dokument.opis }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- New message btn -->
                        <v-btn @click="addCommentDisplay = true" class="btn btn--default-fill btn--sm mt-4">
                            Priloži dokument
                        </v-btn>

                    </v-col>

                    <!-- Contract messages ***************************************************** -->
                    <!-- v-if="pogodbaDetails.Podpis == 'Splet'" -->
                    <v-col class="v-col-5">

                        <!-- Messages title -->
                        <div class="d-flex justify-space-between">
                            <div class="contract-details__title">
                                {{ $t(`SeznamPogodb.PogodbeEdit.Messages`) }}
                            </div>

                            <!-- New message btn -->
                            <v-btn @click="addCommentDisplay = true" class="btn btn--default-fill btn--sm">
                                {{ $t(`SeznamPogodb.PogodbeEdit.BtnMessage`) }}
                            </v-btn>
                        </div>

                        <!-- Loader -->
                        <div v-show="seznamPogodbStore.Helpers.ShowCommentsLoader" class="loader loader--messages">
                        </div>

                        <!-- Messages -->
                        <div class="contract-details__messages">

                            <!-- NLB default message-->
                            <div v-if="pogodbaDetails.NoDoc === false" class="contract-details__message">
                                <div class="contract-details__message__header">

                                    <!-- Message author -->
                                    <div class="contract-details__message__author">
                                        <div>NLB Buy&Go</div>
                                    </div>

                                    <!-- Message timestamp -->
                                    <!-- <div class="contract-details__message__timestamp">
                                        29.4.2025 8:30:00
                                    </div> -->

                                </div>
                                <!-- Message content -->
                                <div class="contract-details__message__content">
                                    <div class="contract-details__message__text-wrap">
                                        <!-- Message text -->
                                        <div class="contract-details__message__text">
                                            <div class="">
                                                <span class="font-weight-600">Stranka je prejela SMS s povezavo za
                                                    prilaganje potrebne dokumentacije.
                                                    Vso nadaljno komunikacijo s stranko vodimo pri NLB Buy&Go.</span>
                                                Blago lahko
                                                izdate, ko se bo status pogodbe spremenil v Odobreno.
                                            </div>

                                            <div class=" mt-4">
                                                V primeru, da želite dokumentacijo stranke priložiti na prodajnem mestu,
                                                lahko to storite s klikom na gumb Priloži dokument ali Novo sporočilo.
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div v-if="pogodbaDetails.Komentarji.length == 0 && pogodbaDetails.NoDoc === true"
                                class="no-messages">
                                <img src="@assets/images/contract-list/icon-message-default.svg" alt="Messages">
                                <div class="no-messages__title">Ni sporočil</div>
                                <div>
                                    Za pošiljanje sporočila ali dokumentacije izberite Novo sporočilo.
                                </div>
                            </div>

                            <PogodbaKomentar v-else :Komentarji="pogodbaDetails.Komentarji" />
                        </div>

                    </v-col>

                </v-row>

                <!-- Modal New message -->
                <Modal :title="$t(`SeznamPogodb.ModalComment.Title`)" :display="addCommentDisplay"
                    @modalClosed="addCommentDisplay = false" :closeText="$t(`SeznamPogodb.ModalComment.CloseBtn`)"
                    :acceptText="$t(`SeznamPogodb.ModalComment.SaveBtn`)" @accept="AddContractComment()"
                    class="modal-summit-comments">

                    <!-- Loader -->
                    <div class="loader loader-large loader-modal ">
                        <img src="@assets/images/general/loader-nlb-large.svg" alt="Loader">
                    </div>


                    <div>
                        <!-- Message -->
                        <div>
                            <label class="form-label">{{ $t(`SeznamPogodb.ModalComment.InputLabel`) }}</label>
                            <v-textarea v-model="v$.Comment.$model"
                                :error-messages="v$.Comment.$errors[0] != null ? v$.Comment.$errors[0].$message : ''"
                                @focus="v$.Comment.$reset" variant="outlined" rows="2">
                            </v-textarea>
                        </div>

                        <!-- Attach file -->
                        <div class="mb-6">
                            <label class="form-label">{{ $t(`SeznamPogodb.ModalComment.FileLabel`) }}</label>
                            <div>
                                <FileUpload v-model="seznamPogodbStore.CommentNew.Files" :error="v$.Files.$error"
                                    :errorText="v$.Files.$errors[0] != null ? v$.Files.$errors : []"
                                    :infoText="$t(`SeznamPogodb.ModalComment.FileInfo`)">
                                </FileUpload>
                            </div>
                        </div>

                        <!-- File type -->
                        <div>
                            <label class="form-label">
                                Vrsta pripetega dokumenta
                            </label>
                            <v-radio-group v-model="seznamPogodbStore.CommentNew.FileType" :error="v$.FileType.error"
                                :error-messages="v$.FileType.$errors[0] != null ? v$.FileType.$errors[0].$message : ''"
                                @focus="v$.FileType.$reset"
                                hint="Prosimo izberite vrsto dokumenta, ki ste ga priložili." persistent-hint>
                                <v-radio label="Naročilo, predračun, ponudba ali račun"
                                    :value="AttachedDocType.POS_INVOICE">
                                </v-radio>
                                <v-radio label="Drugo" :value="AttachedDocType.OTHER">
                                </v-radio>
                            </v-radio-group>
                        </div>

                    </div>
                </Modal>

                <!-- Modal Storno -->
                <Modal :title="$t(`SeznamPogodb.ModalStorno.Title`)" :display="stornoDisplay"
                    @modalClosed="StornoClose()" :closeText="$t(`SeznamPogodb.ModalStorno.CloseBtn`)"
                    :acceptText="$t(`SeznamPogodb.ModalStorno.SaveBtn`)" @accept="ContractStorno()"
                    class="modal-summit-comments">
                    <div class="">
                        <label class="form-label">{{ $t(`SeznamPogodb.ModalStorno.InputLabel`) }}</label>
                        <v-textarea v-model="seznamPogodbStore.PogodbaDetails.StornoComment"
                            :error-messages="v2$.StornoComment.$errors[0] != null ? v2$.StornoComment.$errors[0].$message : ''"
                            @focus="v2$.StornoComment.$reset" variant="outlined" rows="2">
                        </v-textarea>
                    </div>

                </Modal>

                <!-- Modal podpis -->
                <Modal :display="seznamPogodbStore.ESignLater.showPodpis"
                    @modalClosed="seznamPogodbStore.ESignLater.showPodpis = false" :showAcceptButton="false"
                    :showDeclineButton="false" class="dialog-preview">
                    <DocumentSigner :url="seznamPogodbStore.ESignLater.Url" frameBorder="0" />
                </Modal>

            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
    import router from "@app/router";
    import PogodbaKomentar from "@components/contract-comment.vue";
    import { IPogodbaDetails, useSeznamPogodbStore, IPogodbaCommentNew, AttachedDocType } from "@/app/store/app/contract-list/store";
    import { ComputedRef, computed, Ref, ref } from "vue";
    import { getDateTimeCorrectedFormat } from "@/app/utils/date-functions";
    import Modal from "@/app/components/modal.vue";
    import DocumentSigner from "@components/document-signer.vue";
    import { useVuelidate } from "@vuelidate/core";
    import { LoaderComponent, FileUpload } from "nlb-buy-go-library";
    import { PogodbaStatus } from "@/app/store/app/contract-list/store";
    import { i18n } from "@app/i18n";
    import { helpers, requiredIf, required } from "@vuelidate/validators";
    import { useFw4Store } from "fw4-library";
    import { useDokoncanjePogodbeStore } from "@/app/store/app/contract-completion/store";
    import iconDefault from '@assets/images/pages/contracts/icon-document-status-default.svg'
    import iconSuccess from '@assets/images/pages/contracts/icon-document-status-success.svg'
    import { useLoaderData } from "@/app/store/app/component/loader-component";


    const { ViewLoaderData } = useLoaderData();

    const fw4 = useFw4Store();

    const props = defineProps({
        id: {
            type: String
        }
    });

    function getDocumentStatusIcon(nalozen: boolean): string {
        return nalozen ? iconSuccess : iconDefault
    }

    const seznamPogodbStore = useSeznamPogodbStore();
    const dokoncanjePogodbeStore = useDokoncanjePogodbeStore();
    seznamPogodbStore.getPogodbaDetails(parseInt(props.id!));

    const pogodbaDetails: ComputedRef<IPogodbaDetails> = computed(() => seznamPogodbStore.PogodbaDetails);
    const newComment: ComputedRef<IPogodbaCommentNew> = computed(() => seznamPogodbStore.CommentNew);

    function RenderReport(reportMethod: string, reportName: string) {
        fw4.ShowReport(
            {
                Title: "",
                MethodName: reportMethod,
                Parameters: { "PogodbaId": props.id },
                FileName: reportName + "_" + props.id
            });
    }

    let addCommentDisplay: Ref<boolean> = ref(false);

    async function ContractStorno() {
        await validateStornoForm().then(() => {
            v2$.value.$reset();
            seznamPogodbStore.PogodbaStorno()
                .then(() => {
                    seznamPogodbStore.getPogodbaDetails(pogodbaDetails.value.PogodbaId);
                    stornoDisplay.value = false;
                });
        });
    }

    async function StornoClose() {
        pogodbaDetails.value.StornoComment = "";
        stornoDisplay.value = false;
    }

    async function AddContractComment() {
        await validateForm().then(() => {
            v$.value.$reset();
            seznamPogodbStore.addContractComment()
                .then(() => {
                    addCommentDisplay.value = false;
                });
        });
    }

    let stornoDisplay: Ref<boolean> = ref(false);

    function back() {
        router.back();
    }

    //Comment Validation

    async function validateForm(): Promise<void> {
        v$.value.$touch();
        let formValid = await v$.value.$validate();
        return new Promise((resolve) => {
            if (formValid) {
                resolve();
            }
        });
    };

    const validationRules = computed(() => ({
        Comment: {
            required: helpers.withMessage(i18n.global.t("GlobalErrors.FIELD_REQUIRED"), requiredIf(newComment.value.Files.length == 0 && newComment.value.Comment == "")),
        },
        Files: {
            required: helpers.withMessage(i18n.global.t("GlobalErrors.FIELD_REQUIRED"), requiredIf(newComment.value.Files.length == 0 && newComment.value.Comment == "")),
        },
        FileType: {
            requiredIf: helpers.withMessage(i18n.global.t("GlobalErrors.FIELD_REQUIRED"), requiredIf(newComment.value.Files.length > 0)),

        }
    }));

    const v$: any = useVuelidate(validationRules, newComment);

    // storno validation
    async function validateStornoForm(): Promise<void> {
        v2$.value.$touch();
        let formValid = await v2$.value.$validate();
        return new Promise((resolve) => {
            if (formValid) {
                resolve();
            }
        });
    };

    const validationRules2 = computed(() => ({
        StornoComment: {
            required: helpers.withMessage(i18n.global.t("GlobalErrors.FIELD_REQUIRED"), required),
        },
    }));

    const v2$: any = useVuelidate(validationRules2, pogodbaDetails);

</script>